import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { setArchivedJobs } from 'ducks/concurrency'
import { useModal, useSnackbar } from 'hooks'
import { getOrm } from 'orm/selectors'

const useArchiveJobsModalMutations = ({ archived }) => {
  const dispatch = useDispatch()

  const handleArchiveJobs = React.useCallback(
    ({ onShowSnackbar }) => {
      dispatch(setArchivedJobs(onShowSnackbar, archived))
    },
    [dispatch, archived],
  )

  return {
    handleArchiveJobs,
  }
}

export const useArchiveJobsModalState = () => {
  const { projects } = useSelector(getOrm)

  const pks = Object.keys(projects?.meta?.selected ?? {})

  const count = pks.length

  const jobs = Object.values(projects?.items ?? {}).filter(
    (job): job is { id: number | string; name?: string } =>
      typeof job === 'object' &&
      job !== null &&
      'id' in job &&
      (typeof job.id === 'number' || typeof job.id === 'string') &&
      pks.includes(job.id.toString()),
  )

  return {
    state: {
      count,
      jobs,
      pks,
    },
  }
}

export const useArchiveJobsModal = ({ archived }) => {
  const { isOpen, handleClose, handleOpen } = useModal()

  const {
    handlers: { handleShowSnackbar },
  } = useSnackbar()

  const { handleArchiveJobs } = useArchiveJobsModalMutations({ archived })

  const handleConfirm = React.useCallback(() => {
    handleArchiveJobs({ onShowSnackbar: handleShowSnackbar })
    handleClose()
  }, [handleClose, handleArchiveJobs, handleShowSnackbar])

  return {
    handleArchiveJobsModalClose: handleClose,
    handleArchiveJobsModalConfirm: handleConfirm,
    handleArchiveJobsModalOpen: handleOpen,
    isArchiveJobsModalOpen: isOpen,
  }
}
